KCVS.Views.UserReportInvoiceRowsTable =
  template: JST['user_report_rows/invoice_rows_table']()

  mounted: ->
    @fetchInvoiceRows()

  data: ->
    rows: []

  computed:
    applicable_sum: ->
      _.reduce(@rows, ((memo, row)-> memo + parseFloat row.applicable_amount), 0.00)

  methods:
    updateRow: (row) ->
      arrayRow = _.find(@rows, (s_row) -> s_row.id == row.id )
      oldRowIndex = _.indexOf(@rows, arrayRow)
      @rows[oldRowIndex] = row

    fetchInvoiceRows: ->
      $.ajax
        url: "/project_partner_report_periods/#{@.$root.projectPartnerReportPeriodId}/report_rows.json"
        method: 'GET'
        dataType: 'JSON'
        success: (data) =>
          @rows = data
